import React, { useState } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import Paper from '@material-ui/core/Paper'
import AppBar from '@material-ui/core/AppBar'
import Toolbar from '@material-ui/core/Toolbar'
import Typography from '@material-ui/core/Typography'
import IconButton from '@material-ui/core/IconButton'
import IconKeyboardArrowUp from '@material-ui/icons/KeyboardArrowUp'
import IconKeyboardArrowDown from '@material-ui/icons/KeyboardArrowDown'
import { withStyles } from '@material-ui/core/styles'


const styles = {
  root: {
    marginTop: 30,
    borderRadius: 3,
    backgroundColor: 'white',
  },
  header: {
    borderRadius: '3px 3px 0 0',
  },
  flexGrow: {
    flexGrow: 1,
  },
  menuButton: {
    marginLeft: -12,
    marginRight: 30,
  },
  content: {
    padding: 15,
    height: 'calc(100% - 64px)',
  },
}


const Section = ({
  title,
  classes,
  children,
  className,
  closedByDefault,
  contentClassName,
  toolbarRightComponent: ToolbarRightComponent,
}) => {
  const [open, setOpen] = useState(!closedByDefault)

  const toggleOpen = () => setOpen(!open)

  return (
    <Paper
      square
      className={classNames(classes.root, className)}
    >
      <AppBar
        color="default"
        position="static"
        className={classes.header}
      >
        <Toolbar>
          <IconButton
            color="inherit"
            aria-label="Menu"
            onClick={toggleOpen}
            className={classes.menuButton}
          >
            {open && <IconKeyboardArrowDown />}
            {!open && <IconKeyboardArrowUp />}
          </IconButton>

          <Typography
            variant="h6"
            color="inherit"
            className={classes.title}
          >
            {title}
          </Typography>

          {ToolbarRightComponent}
        </Toolbar>
      </AppBar>

      <div
        style={{ display: open ? 'block' : 'none' }}
        className={classNames(classes.content, contentClassName)}
      >
        {children}
      </div>
    </Paper>
  )
}


Section.defaultProps = {
  title: '',
  classes: {},
  children: [],
  className: null,
  closedByDefault: false,
  toolbarRightComponent: null,
}


Section.propTypes = {
  title: PropTypes.string,
  children: PropTypes.node,
  classes: PropTypes.object,
  className: PropTypes.string,
  closedByDefault: PropTypes.bool,
  contentClassName: PropTypes.string,
  toolbarRightComponent: PropTypes.node,
}


export default withStyles(styles)(Section)
